import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import { CgClose } from "react-icons/cg";

interface ModalBlankTemplateProps {
  visibleModal: boolean | string;
  setVisibleModal: React.Dispatch<React.SetStateAction<any>>;
  title: string | JSX.Element;
  body?: string | JSX.Element;
  footer?: string | JSX.Element;
  center?: boolean;
  centered?: boolean;
  noOnHide?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}

export const ModalBlankTemplate: React.FC<ModalBlankTemplateProps> = ({ visibleModal, setVisibleModal, title, body, footer, center, centered, noOnHide, size }) => {
  const handleClose = () => setVisibleModal(typeof visibleModal === 'boolean' ? false : '');

  return (
    <Modal show={visibleModal} onHide={noOnHide ? undefined : handleClose} size={size} centered={centered}>
      <Modal.Header className="pt-4 mt-2 justify-content-center" >
        <Modal.Title>{title}</Modal.Title>
        {!noOnHide && <CgClose size='30px' className='Close' onPointerDown={handleClose} cursor='pointer' data-testid='ModalBlankTemplate-Close' />}
      </Modal.Header>
      {body && <Modal.Body className={`pt-0 pb-2 justify-content-center ${center && 'text-center'}`}>
        {body}
      </Modal.Body>}
      <Modal.Footer className="p-0 pb-3 mb-1 justify-content-center">
        {footer ? footer : <Button variant="primary" onPointerDown={handleClose}>
          Ok
        </Button>}
      </Modal.Footer>
    </Modal>
  );
};